/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ContractGroupDto } from './contractGroupDto.model';


export interface ListResponseContractGroupDto { 
    itemCount?: number;
    items?: Array<ContractGroupDto>;
    params?: { [key: string]: any; };
}

